import { getApiBaseUrl, getApiClient } from "./serviceconfig";

var apiBaseUrl = getApiBaseUrl();

export async function getDashboardDetails(cookies, plant_id, from_date, upto_date) {
  let url = `${apiBaseUrl}/dashboard?plant_id=${plant_id}&from_date=${from_date}&upto_date=${upto_date}`;
  return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getSalesList(cookies, plant_id, from_date, upto_date) {
  let url = `${apiBaseUrl}/dashboard/sales_list?plant_id=${plant_id}&from_date=${from_date}&upto_date=${upto_date}`;
  return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getPurchaseList(cookies, plant_id, from_date, upto_date) {
  let url = `${apiBaseUrl}/dashboard/purchase_list?plant_id=${plant_id}&from_date=${from_date}&upto_date=${upto_date}`;
  return getApiClient(cookies).get(url).then((response) => response.data);
}

export async function getQAQCDashBoardList(
  cookies,
  plant_id,
  from_date,
  upto_date,
  type = "ALL"
) {
  let url = `${apiBaseUrl}/qaqc_dashboard/qaqc/?plant_id=${plant_id}&from_date=${from_date}&upto_date=${upto_date}&type=${type}`;
  return getApiClient(cookies).get(url).then((res) => res.data);
}
